import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ── Thunks ────────────────────────────────────────────────────────────────────
// API functions are passed in as arguments because useServicePlanApi() is a
// React hook and cannot be called inside a Redux thunk directly.

export const fetchPlans = createAsyncThunk(
  'servicePlan/fetchPlans',
  async (apiFn, { rejectWithValue }) => {
    // apiFn = plansApi.getAll
    try {
      const res = await apiFn();
      return res.data.data || res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || 'Failed to fetch plans');
    }
  }
);

export const fetchQuestionnaires = createAsyncThunk(
  'servicePlan/fetchQuestionnaires',
  async (apiFn, { rejectWithValue }) => {
    // apiFn = questionnairesApi.getAll
    try {
      const res = await apiFn();
      return res.data.data || res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || 'Failed to fetch questionnaires');
    }
  }
);

export const deletePlan = createAsyncThunk(
  'servicePlan/deletePlan',
  async ({ apiFn, id, label }, { rejectWithValue }) => {
    // apiFn = plansApi.delete
    try {
      await apiFn(id, label);
      return id;
    } catch (e) {
      return rejectWithValue(e.response?.data?.message || 'Failed to delete plan');
    }
  }
);

// ── Slice ─────────────────────────────────────────────────────────────────────

const servicePlanSlice = createSlice({
  name: 'servicePlan',
  initialState: {
    plans:          [],
    questionnaires: [],
    plansLoaded:    false,
    questsLoaded:   false,
    loading:        false,
    error:          null,
  },
  reducers: {
    invalidatePlans(state) {
      state.plansLoaded = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending,   (state)            => { state.loading = true;  state.error = null; })
      .addCase(fetchPlans.fulfilled, (state, { payload }) => { state.plans = payload; state.plansLoaded = true; state.loading = false; })
      .addCase(fetchPlans.rejected,  (state, { payload }) => { state.loading = false; state.error = payload; })

      .addCase(fetchQuestionnaires.fulfilled, (state, { payload }) => { state.questionnaires = payload; state.questsLoaded = true; })

      .addCase(deletePlan.fulfilled, (state, { payload: id }) => { state.plans = state.plans.filter(p => p.id !== id); });
  },
});

export const { invalidatePlans } = servicePlanSlice.actions;
export default servicePlanSlice.reducer;